import { kevinAuthAPI } from 'apis/config';
import ErrorMessage from '../ErrorMessage';
import { ILang, ICoupon } from '../../utils/types/saleTypes';

export const productApis = {
  productList: (projectId: number) =>
    kevinAuthAPI.get(`/product/${projectId}`).then((res) => res.data),
  getProduct: (projectId: number, productId: number) => {
    return kevinAuthAPI
      .get(`/product/${projectId}/${productId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  updateProduct: (data: ICoupon) => {
    return kevinAuthAPI
      .patch(`/product/${data.master_id}`, data)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  createProduct: (projectId: number, data: ICoupon) => {
    return kevinAuthAPI
      .post(`/product/${projectId}/product`, data)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  createProductLang: (projectId: number, productId: number, data: ILang) => {
    return kevinAuthAPI
      .post(`/product/${projectId}/${productId}/lang`, data)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  deleteProduct: (projectId: number, productId: number) => {
    return kevinAuthAPI
      .delete(`/product/${projectId}/${productId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  deleteProductLang: (projectId: number, productId: number, langId: number) => {
    return kevinAuthAPI
      .delete(`/product/${projectId}/${productId}/${langId}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },
  uploadProductBanner: (
    project_id: number,
    product_id: number,
    product_lang_id: number,
    file: any,
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(
        `/product/upload-banner/${project_id}/${product_id}/${product_lang_id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      });
  },

  // itemCreate: (projectId, data) =>
  //   kevinAuthAPI.post(`/item/${projectId}`, data).then((res) => res.data),
  // itemDelete: (projectId, id) =>
  //   kevinAuthAPI.delete(`/item/${projectId}/${id}`).then((res) => res.data),
  // itemUpdate: (projectId, id, data) =>
  //   kevinAuthAPI
  //     .patch(`/item/${projectId}/${id}`, data)
  //     .then((res) => res.data),
  // itemUpdateImage: (projectId, id, data) =>
  //   kevinAuthAPI
  //     .put(`/item/${projectId}/image/${id}`, data)
  //     .then((res) => res.data),
  // itemUpdateIcon: (projectId, id, data) =>
  //   kevinAuthAPI
  //     .put(`/item/${projectId}/icon/${id}`, data, {
  //       headers: { 'Content-Type': 'multipart/form-data' },
  //     })
  //     .then((res) => res.data),
};
